export default __webpack_public_path__ + "static/Mission-Hill-Winery-5622e6a50c9fd9552b7063e062449e3f.jpg";